import { Trans, useTranslation } from 'react-i18next';

import { Alert, ExternalLink } from '~/components';

export const StylingAndInteriorWarning = () => {
  const { t } = useTranslation(['settings']);

  return (
    <Alert announce={false} icon="Warning" status="warning" title={t('settings:profile.activities.warnings.stylingAndInterior.title')}>
      <Trans components={{ a: <ExternalLink /> }} i18nKey="settings:profile.activities.warnings.stylingAndInterior.body" />
    </Alert>
  );
};
